module.exports = __webpack_public_path__ + "media/images/logo_white-f40bacf6e1990b6d5eac6f0d49fca3ee.png";